module.exports = __webpack_public_path__ + "img/tiktok_black.1101d09.svg";